//@flow
import React from "react";

export default function deltaArrowTrendIndicator(value: number, delta: number) {
  let arrow = "";
  let color = "";
  let rotate = 0;
  if (delta === 0) {
    arrow = "double_arrow"; // right
    rotate = 0; // right
    color = "risk-medium";
  }
  if (delta > 0) {
    arrow = "double_arrow"; // up
    rotate = 270;
    color = "risk-very-high";
  }
  if (delta < 0) {
    arrow = "double_arrow"; //left
    rotate = 90;
    color = "risk-low";
  }

  return (
    <div className={"d-flex justify-content-center align-items-center"}>
      <div>{value}</div>
      <div className={`material-icons transform-rotate-${rotate} text-${color} fs-16`}>{arrow}</div>
    </div>
  );
}
